import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("ar_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  const role = localStorage.getItem("ar_role");
  const scope = localStorage.getItem("ar_scope_tenant");
  if (role === "superadmin" && scope) {
    config.params = { ...(config.params || {}), tenant_id: scope };
  }
  return config;
});

export function formatError(detail) {
  if (detail == null) return "Ha ocurrido un error. Inténtelo de nuevo.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export async function descargarRecurso(recurso_tipo, recurso_id) {
  const { data } = await api.post("/descargas/token", { recurso_tipo, recurso_id });
  window.open(data.url, "_blank");
}

export { API };
export default api;
